<template>
    <div class="modal-dialog">
        <div class="add-resume-item-container col-lg-8 col-sm-12 animated backInUp">
            <div class="close-button" @click="hideModalFunction()"><i class="dev-circle-x"></i></div>
            <div class="content">
                <h2><strong>Neues Heldenzeichen erstellen</strong></h2>
                <h4><strong>Heldenzeichen</strong> sind eine Möglichkeit deiner Kreativität Ausdruck zu verleihen.<br>
                    Wie? Ganz einfach mit <strong>Code</strong>. Die Sprache <strong>Logo</strong> ermöglicht es dir
                    einen Stift (<em>Turtle</em>) zu kontrollieren. Allerdings darf das Zeichnen nicht länger als 10 Sekunden dauern. Eine Sprachreferenz findest du <a
                        href="https://people.eecs.berkeley.edu/~bh/v2ch14/manual.html" target="_blank">hier</a>. Viel Spaß!
                </h4>
                <div class="row display-flex-center" style="margin-bottom: 40px;">
                    <div class="col-lg-4 row internalCode-view">
                        <div class="drawing">
                            <vue-logo :code="internalCode" :renderCode="render" :finished="finishedRender"
                                      :timeout="10000" :error="onDrawingError"></vue-logo>
                        </div>
                        <div v-if="drawingError.name" class="traceback alert alert-danger">
                            {{drawingError.name}}<br/>
                            {{drawingError.message}}
                        </div>
                        <div class="col-xs-12 drawing-control">
                            <button v-if="!render" class="btn center-block" @click="startRender" ><i
                                class="dev-edit"></i> Zeichen {{ SaveHotKey }}
                            </button>
                            <button v-if="render" class="btn btn-danger center-block" @click="stopRender" ><i
                                class="dev-x"></i> Abbrechen
                            </button>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-8 logo-editor">
                        <EditorX :programming-language="'logo'" :height="'100%'" :code="internalCode"></EditorX>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger visible-sm-inline visible-lg-inline visible-md-inline" v-if="id != ''" @click="removeDrawingFromProfile()"><i
                        class="dev-delete-bin-2"></i> Löschen
                    </button>
                    <button class="btn btn-danger pull-left hidden-sm hidden-lg hidden-md" @click="removeDrawingFromProfile()"><i
                        class="dev-delete-bin-2"></i></button>
                    <button class="btn btn-secondary" @click="addDrawingToUserProfile()"><i class="dev-save"></i> In
                        Profil Speichern
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade in"></div>
    </div>
</template>

<script>
import {VueLogo} from "vue-logo"
import {eventBus, services} from "../../main";
import EditorX from "../workspace/EditorX";
import Vue from "vue";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
Vue.use(VueToast);

export default {
    name: "AddNewUserDrawingsComponent",
    components: {VueLogo, EditorX},
    props: {
        hideModalFunction: {
            type: Function, default: () => {
            }
        },
        code: {type: String, default: ""},
        id: {type: String, default: null},
    },
    data: function () {
        return {
            render: false,
            drawingError: {},
            internalCode: "to square :length\n    repeat 4 [ fd :length rt 90 ]\nend; \n clearscreen\npenup\nback 50\nlt 90\nfd 50\nrt 90\npendown\nsquare 100",
        };
    },
    created: function () {
        eventBus.$on("editorChangedContent", (code) => {
            this.internalCode = code.fileContent;
        });
        if (this.code){
            this.internalCode = this.code;
        }
        this.startRender()
        this.drawOnSave();
    },
    methods: {
        onDrawingError: function(error) {
            this.drawingError = error
        },
        stopRender: function() {
            this.render = false;
        },
        finishedRender: function () {
            this.render = false;
        },
        startRender: function () {
            this.drawingError = {}
            this.render = true;
        },
        drawOnSave: function () {
            window.onkeydown = function (event) {
                // fetch save command mac
                if (event.which === 83 && event.metaKey || event.which === 83 && event.ctrlKey) {
                    event.preventDefault();
                    this.drawingError = {};
                    this.render = true;
                }
            }.bind(this);
        },
        addDrawingToUserProfile() {
            if (this.internalCode == ""){
                this.hideModalFunction(false);
                Vue.$toast.open({
                    message: 'Dein Heldenzeichen konnte nicht gespeichert werden weil kein Quellcode vorhanden ist',
                    type: 'error',
                    position: 'bottom',
                });
                return;
            }
            services.userService.addOrUpdateLogoDrawingInUserProfile(this.id, this.internalCode)
                .then(() => {
                    this.hideModalFunction(true);
                    Vue.$toast.open({
                        message: 'Dein Heldenzeichen wurde gespeichert',
                        type: 'success',
                        position: 'bottom',
                    });
                })
                .catch(() => {
                    Vue.$toast.open({
                        message: 'Dein Heldenzeichen konnte nicht gespeichert werden',
                        type: 'error',
                        position: 'bottom',
                    });
                })
        },
        removeDrawingFromProfile() {
            if (this.id) {
                services.userService.removeLogoDrawingInUserProfile(this.id)
                    .then(() => {
                        this.hideModalFunction(true);
                        Vue.$toast.open({
                            message: 'Dein Heldenzeichen wurde gelöscht',
                            type: 'success',
                            position: 'bottom',
                        });
                    })
                    .catch(() => {
                        Vue.$toast.open({
                            message: 'Dein Heldenzeichen konnte nicht gelöscht werden',
                            type: 'error',
                            position: 'bottom',
                        });
                    })
                return;
            }
            this.hideModalFunction(true);
        }
    },
    computed: {
        SaveHotKey() {
            if (window.navigator.platform === "Win32") {
                return "Ctrl + S";
            }
            return "⌘S";
        }
    }
}
</script>

<style scoped>
.drawing {
    width: 270px;
    height: 270px;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    background: white;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 3rem;
}

.content h4 {
    line-height: 1.5em;
}

.content a {
    font-weight: bold;
    text-decoration: underline;
}

h4 {
    margin-bottom: 3rem;
}

.add-resume-item-container {
    position: fixed;
    left: 0;
    right: 0;
    margin: 0 auto;
    background: linear-gradient(45deg, #f6f9fc, white);
    padding: 30px 50px 30px 50px;
    border-radius: 10px;
    box-shadow: 0px 10px 100px rgba(0, 0, 0, 0.55);
    overflow: visible;
    z-index: 1041;
}

.content {
    width: 100%;
    position: relative;
    margin: 0 auto;
}

@keyframes backInUp {
    0% {
        zoom: 0.7;
        top: 100%;
        opacity: .7
    }
    80% {
        zoom: 0.7;
        top: 5%;
        opacity: .7
    }
    to {
        zoom: 1;
        top: 5%;
        opacity: 1
    }
}

@media (max-height: 1300px) and (max-width: 992px), (max-height: 850px){
    @keyframes backInUp {
        0% {
            zoom: 0.7;
            top: 100%;
            opacity: .7
        }
        80% {
            zoom: 0.7;
            top: 0;
            opacity: .7
        }
        to {
            zoom: 1;
            top: 0;
            opacity: 1
        }
    }
    .add-resume-item-container {
        overflow-y: scroll;
        height: 100vh;
        border-radius: 0;
        padding: 10px 15px 10px 15px;
    }
}

.backInUp {
    -webkit-animation-name: backInUp;
    animation-name: backInUp;
    animation-duration: .5s;
    animation-timing-function: ease-out;
}

.close-button:hover {
    color: black;

}

.close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 30px;
    color: #8f8f8f;
    cursor: pointer;
    z-index:300;
}

.modal-footer {
    border-top: 0px;
    padding: 0px;
    /*font-size: 15px;*/
}

.drawing-control {
    font-size: 14px;
}

@media (min-width: 992px) {
    .display-flex-center {
        display: flex;
        align-items: center;
    }

    .logo-editor {
        max-height: 600px;
        max-width: calc(100% - 320px);
    }

    .internalCode-view {
        margin-left: 20px;
    }
}

@media (max-width: 992px) {
    .internalCode-view {
        margin-bottom: 40px;
    }
}

.modal-footer .btn:not(.pull-left) {
    margin-left: 20px;
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

@keyframes scale {
    0%, 100% {
        transform: none;
    }
    50% {
        transform: scale3d(1.1, 1.1, 1);
    }
}

.modal-footer .btn + .btn, .modal-footer .btn {
    margin-bottom: 15px;
}

.internalCode-view {
    min-width: 300px;
}

.traceback {
    font-family: "Source Code Pro", monospace;
}

.btn-danger {
    background-color: #cc5252;
    border-color: rgba(0, 0, 0, 0.1);
    outline: none !important;
    box-shadow: none;
    color: white;
}

.btn-danger:hover {
    background-color: #aa4949;
    border-color: rgba(0, 0, 0, 0.2);
    color: white;
}

.btn-danger:focus,
.btn-danger:active,
.btn-danger:active:focus {
    background-color: #a13636;
    border-color: rgba(0, 0, 0, 0.2);
    color: white;
}

</style>